'use client'

import Image from 'next/image';
import { useMemo } from 'react';
import React from 'react';

export interface FluidImage {
  aspectRatio: number;
  src: string;
  srcSet?: string | null;
  sizes: string;
  width?: number;
  height?: number;
  base64?: string | null;
  srcWebp?: string | null;
  srcSetWebp?: string | null;
}

interface ContentfulImageProps {
  fluid: FluidImage;
  alt: string;
  className?: string;
  priority?: boolean;
  dataTestId?: string;
  dataAos?: string;
  style?: React.CSSProperties;
  imgStyle?: React.CSSProperties;
  conatainerStyle?: React.CSSProperties;
}

export default function ContentfulImage({ 
  fluid,
  dataTestId,
  alt,
  className,
  dataAos,
  imgStyle,
  conatainerStyle,
  priority = false,
}: Readonly<ContentfulImageProps>) {

  const imageProps = useMemo(() => {
    return {
      src: fluid.src,
      fill: true,
      sizes: fluid.sizes || '100vw',
      quality: 75,
    };
  }, [fluid]);

  return (
    <div 
      className={className} 
      style={{
        position: 'relative',
        aspectRatio: fluid.aspectRatio,
        ...conatainerStyle
      }}
    >
        <Image
          {...imageProps}
          data-testid={dataTestId}
          alt={alt}
          data-aos={dataAos}
          priority={priority}
          style={{
            ...imgStyle,
            objectFit: 'contain',
            width: '100%',
          }}
        />
    </div>
  );
}
